import React, { Component } from 'react';

export class NewsPage extends Component {
    state = { 
        info: {}
    }

    componentDidMount = () => {
        const {info} = this.props.location.state;
        this.setState({info});
        document.title = 'AGT - ' + info.title;
    }

    render() { 
        return ( 
            <React.Fragment>
            <div class="text-center">
                <h1 class="heading" style={{color: '#EE3124'}}>{this.state.info['title']}</h1>
            </div>
            <div class="text-left ml-5">
                <p>{this.state.info['text']}</p>
<p>{this.state.info['text1']}</p>
<p>{this.state.info['text2']}</p>
<p>{this.state.info['text3']}</p>
<p>{this.state.info['text4']}</p>
<p>{this.state.info['text5']}</p>
<p>{this.state.info['text6']}</p>
<p>{this.state.info['text7']}</p>
<p>{this.state.info['text8']}</p>
<p>{this.state.info['text9']}</p>
<p>{this.state.info['text10']}</p>
<p>{this.state.info['text11']}</p>
<p>{this.state.info['text12']}</p>
<p>{this.state.info['text13']}</p>
<p>{this.state.info['text14']}</p>
<p>{this.state.info['text15']}</p>
<p>{this.state.info['text16']}</p>
<p>{this.state.info['text17']}</p>
<p>{this.state.info['text18']}</p>
<p>{this.state.info['text19']}</p>
<p>{this.state.info['text20']}</p>
            </div>
            </React.Fragment>
        );
    }
}
 



